







































































































































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { SwatchSearchOptions, PageConfig } from "../../types";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import { formatDateForQuery } from "@/utils";
export default Vue.extend({
  name: "search-projects",
  data() {
    return {
      search: {
        placeholder:
          "Search by item name, brand, product code, display name,etc.",
        buttonText: "Search",
        isDropdownAvailable: true,
        dropdownOptions: SwatchSearchOptions,
        dropdownSelected: {} as { name: string; display_name: string },
        searchText: ""
      },
      isDateFilterOpen: false,
      dateFilter: {
        start_date: null as Date | null,
        end_date: null as Date | null
      }
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement"
    }),
    ...mapState("appModule", {
      user: "loggedInUser",
      selectedEc: "selectedEc",
      breadcrumb: "breadcrumb"
    })
  },
  methods: {
    ...mapActions("appModule", [
      "searchInventoryProducts",
      "searchInventorySamples",
      "downloadTemplatePdf"
    ]),
    handleSearchClick(searchData: {
      searchText: string;
      option: { name: string; display_name: string };
    }) {
      if (searchData && searchData.option) {
        this.search.searchText = searchData.searchText;
        this.onProductSearch(searchData);
      }
    },
    onProductSearch(searchData: {
      searchText: string;
      option: { name: string; display_name: string };
    }) {
      let pageConfig = PageConfig;
      const apiQuery = {
        [searchData.option.name]: searchData.searchText,
        limit: pageConfig.limit,
        offset: pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      pageConfig.query = encodeQueryParams(apiQuery);
      const routeLink =
        "/" +
        this.selectedEc.name +
        "/inventory/" +
        JSON.stringify({
          data: "Inventory",
          search: searchData,
          pageConfig: pageConfig
        });
      this.$router.push({
        path: routeLink
      });
    },
    goToaddNewItem() {
      this.$router.push({ path: "/" + this.selectedEc.name + "/add" });
    },
    handleUpdateRoute(routeData: {
      to: string;
      data: { sku_code: any; sku_name: any };
    }) {
      let urlQuery = "",
        routeLink = "",
        activeRoute = "",
        apiQuery = {},
        pageConfig = PageConfig;
      if (routeData.to === "skus") {
        apiQuery = {
          product_code: routeData.data.sku_code,
          limit: pageConfig.limit,
          offset: pageConfig.offset,
          ec_id__in: this.selectedEc.name
        };
        pageConfig.query = encodeQueryParams(apiQuery);
        urlQuery = JSON.stringify({
          data: routeData.data.sku_name.name,
          sku_code: routeData.data.sku_code,
          pageConfig: pageConfig
        });
        routeLink =
          "/" +
          this.selectedEc.name +
          "/inventory/" +
          this.$router.currentRoute.params.searchQuery +
          "/" +
          urlQuery +
          "/skus";
      } else if (routeData.to === "samples") {
        apiQuery = {
          sku_code: routeData.data.sku_code,
          limit: pageConfig.limit,
          offset: pageConfig.offset,
          ec_id__in: this.selectedEc.name
        };
        pageConfig.query = encodeQueryParams(apiQuery);
        urlQuery = JSON.stringify({
          data: routeData.data.sku_name.name,
          sku_code: routeData.data.sku_code,
          pageConfig: pageConfig
        });
        routeLink =
          "/" +
          this.selectedEc.name +
          "/inventory/" +
          this.$router.currentRoute.params.searchQuery +
          "/" +
          this.$router.currentRoute.params.productQuery +
          "/" +
          urlQuery +
          "/samples";
      }
      activeRoute = routeData.to;
      this.$router.push({ path: routeLink });
    },
    breadcrumbRouteClicked(eventData: {
      name: string;
      display_name: string;
      href: string;
      routerLink: string;
    }) {
      this.$store.dispatch("appModule/updateBreadcrumb", {
        data: eventData,
        router: this.$router
      });
    },
    updateBreradcrumb() {
      //update the breadcrumb from the route when reload and then goto that route
      let query,
        routeLink,
        activeRoute = "inventory",
        paramsJSON;
      if (this.$router.currentRoute.params.searchQuery) {
        //take the data of searchbar from the jsonparams and update
        paramsJSON = JSON.parse(this.$router.currentRoute.params.searchQuery);
        this.search.searchText = paramsJSON.search.searchText;
        this.search.dropdownSelected = paramsJSON.search.option;
        activeRoute = "inventory";
        this.$store.dispatch("appModule/updateBreadcrumb", {
          data: {
            name: "inventory",
            display_name: "Inventory",
            href: "",
            routerLink:
              "/" +
              this.selectedEc.name +
              "/inventory/" +
              this.$router.currentRoute.params.searchQuery
          },
          router: this.$router
        });
        if (this.$router.currentRoute.params.productQuery) {
          paramsJSON = JSON.parse(
            this.$router.currentRoute.params.productQuery
          );
          activeRoute = "skus";
          this.$store.dispatch("appModule/updateBreadcrumb", {
            data: {
              name: "skus",
              display_name: paramsJSON.data,
              href: "",
              routerLink:
                "/" +
                this.selectedEc.name +
                "/inventory/" +
                this.$router.currentRoute.params.searchQuery +
                "/" +
                this.$router.currentRoute.params.productQuery +
                "/skus"
            },
            router: this.$router
          });
          if (this.$router.currentRoute.params.skuQuery) {
            paramsJSON = JSON.parse(this.$router.currentRoute.params.skuQuery);
            activeRoute = "samples";
            this.$store.dispatch("appModule/updateBreadcrumb", {
              data: {
                name: "samples",
                display_name: paramsJSON.data,
                href: "",
                routerLink:
                  "/" +
                  this.selectedEc.name +
                  "/inventory/" +
                  this.$router.currentRoute.params.searchQuery +
                  "/" +
                  this.$router.currentRoute.params.productQuery +
                  "/" +
                  this.$router.currentRoute.params.skuQuery +
                  "/samples"
              },
              router: this.$router
            });
          }
        }
      }
      this.breadcrumb.routeActive = activeRoute as string;
    },
    customYearPredictor(
      customizedDate: Date,
      selectedDate: Date | null = null
    ) {
      if (
        selectedDate &&
        selectedDate.getFullYear()! == customizedDate.getFullYear()
      ) {
        return true;
      } else return false;
    },
    isStartDateDisabled(currentDateObject: Date) {
      //allow all dates
      return false;
    },
    isEndDateDisabled(currentDateObject: Date) {
      //disable all dates before startdate if any
      if (this.dateFilter.start_date) {
        if (
          currentDateObject.getTime() <
          new Date(this.dateFilter.start_date).getTime()
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    setStartDate(date: Date) {
      if (
        this.dateFilter.end_date &&
        this.dateFilter.start_date &&
        this.dateFilter.end_date.getTime() <
          (this.dateFilter as any).start_date.getTime()
      ) {
        this.dateFilter.end_date = null;
      }
      this.$set(this.dateFilter, "start_date", date);
    },
    setEndDate(date: Date) {
      this.$set(this.dateFilter, "end_date", date);
    },
    cancelFilter() {
      this.dateFilter = {
        start_date: null,
        end_date: null
      };
      this.isDateFilterOpen = false;
    },
    getInventoryPdf() {
      let queryPageConfig = JSON.parse(JSON.stringify(PageConfig));
      let query = {
        limit: 1000,
        offset: 0,
        ec_id__in: this.selectedEc.name,
        created_at__range: formatDateForQuery(
          new Date(this.dateFilter.start_date as Date),
          new Date(this.dateFilter.end_date as Date)
        )
      };
      queryPageConfig.query = encodeQueryParams(query);
      this.searchInventorySamples(queryPageConfig)
        .then((response: { data: any }) => {
          if (response.data.length > 0) {
            this.transformAndDownloadPDF(response.data);
          } else {
            this.$store.dispatch("uiModule/addToast", {
              severity: "error",
              message: "No results found",
              duration: 0
            });
          }
        })
        .catch(err => {
          this.$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: err.error,
            duration: 0
          });
        });
    },
    transformAndDownloadPDF(data: { [key: string]: any }[]) {
      const transformedresults = {
        samples: data.map(sample => {
          return {
            sample_id: sample.sample_id.substring(0, 35),
            location: sample.location.substring(0, 35)
          };
        })
      };
      this.downloadTemplatePdf(transformedresults).then(resp => {
        resp.blob().then((body: any) => {
          const fileURL = URL.createObjectURL(body);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = "samples-" + new Date().getTime().toString() + ".pdf";
          document.body.append(link);
          link.click();
          link.remove();
          // in case the Blob uses a lot of memory
          window.addEventListener("focus", e => URL.revokeObjectURL(link.href), {
            once: true
          });
        });
      });
    },
    handleInitComponent() {
      this.search.searchText = "";
      this.search.dropdownSelected = this.search.dropdownOptions[0];
      this.onProductSearch({
        searchText: this.search.searchText,
        option: this.search.dropdownSelected
      });
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === "inventory") {
      this.search.searchText = "";
      this.search.dropdownSelected = this.search.dropdownOptions[0];
      this.handleInitComponent();
    } else {
      next();
    }
  },
  created() {
    if (!this.$router.currentRoute.params.searchQuery) {
      this.handleInitComponent();
    }
    this.updateBreradcrumb();
  }
});
